import { Checkbox, Text } from "@mantine/core";
import dayjs from "dayjs";
import { type IDraftEntry } from "src/pages/Settings/Miscellaneous/DraftEntries/DraftEntries";
import { StyledTd, StyledTr } from "src/styled";

interface Props {
  row: IDraftEntry;
  checked: boolean;
  onClick: () => void;
}

const DraftEntryRow = ({ row, checked, onClick }: Props) => {
  return (
    <StyledTr pointer onClick={onClick}>
      <StyledTd>
        <Text color="inherit">{row.lbname}</Text>
        {row.sect && (
          <Text color="inherit" ml={10}>
            {row.sect}
          </Text>
        )}
      </StyledTd>
      <StyledTd>
        {row.datecreated || row.deldate
          ? dayjs(row.deldate ?? row.datecreated).format("D MMM YYYY - HH:mm")
          : ""}
      </StyledTd>
      <StyledTd>{row.full_name}</StyledTd>
      <StyledTd>
        <Checkbox mx="auto" w="max-content" defaultChecked={checked} />
      </StyledTd>
    </StyledTr>
  );
};

export default DraftEntryRow;
